<script setup lang="ts">
import { useScreenSize } from '@/composables/screen-size'
import { AppButton, useDialog } from 'lilasia-ui'
import { useI18n } from 'vue-i18n'
import ShareProductModal from './ShareProductModal.vue'

const { t } = useI18n()
const { showDialog } = useDialog()
const { isMobile, isTablet } = useScreenSize()

const showShareModal = () => {
  showDialog(ShareProductModal)
}
</script>

<template>
  <AppButton
    v-if="isMobile"
    icon="share"
    @click="showShareModal"
  />
  <AppButton
    v-else
    color="light"
    :icon="{ name: 'share', size: 20 }"
    :text="t('share')"
    :block="isTablet"
    @click="showShareModal"
  />
</template>
